(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bp-card-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
  // Preload the hover image on pointer OR keyboard focus, so keyboard
  // users get the same instant swap mouse users do.
  function preload(sw) {
    if (!sw || sw.__bpHovered) return;
    sw.__bpHovered = true;
    var url = sw.dataset.bpCardSwatchHover;
    if (url) { var p = new Image(); p.src = url; }
  }
  document.addEventListener('mouseover', function (e) {
    preload(e.target.closest('[data-bp-card-swatch-hover]'));
  }, { passive: true });
  document.addEventListener('focusin', function (e) {
    preload(e.target.closest('[data-bp-card-swatch-hover]'));
  });

  // ── Card title: strip the selected colour off the product name (Atlas
  // parity). BP colourway products carry the colour in the title
  // ("… Coordinate Set Black/White"); the card must show the base name and
  // re-assert it on every render + colour change. This is done here (not
  // just at BR render time) so it self-heals across BR grid renders,
  // swatch hydration, and swatch clicks. Idempotent: once the trailing
  // colour is gone, re-running is a no-op, so it can't loop the observer.
  // Cards with no swatch (e.g. keyword search) have no colour to key off →
  // left untouched.
  function activeSwatchColor(card) {
    var a = card.querySelector('[data-bp-card-swatch-image].bp-card__swatch--active, [data-bp-card-swatch-image][aria-current="true"]')
         || card.querySelector('[data-bp-card-swatch-image]');
    return a ? (a.getAttribute('aria-label') || '').trim() : '';
  }
  function stripTrailingColor(title, color) {
    if (!title || !color) return title;
    var c = color.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var out = title.replace(new RegExp('\\s*[-\\u2013\\u2014/]?\\s*' + c + '\\s*$', 'i'), '').trim();
    return out || title;
  }
  function cleanCardTitle(card) {
    if (!card) return;
    var link = card.querySelector('.bp-card__title a, .bp-card__title');
    if (!link) return;
    var color = activeSwatchColor(card);
    if (!color) return;
    var text = (link.textContent || '').trim();
    var clean = stripTrailingColor(text, color);
    if (clean !== text) link.textContent = clean;
  }
  function cleanAllCardTitles() {
    var cards = document.querySelectorAll('.bp-card');
    for (var i = 0; i < cards.length; i++) cleanCardTitle(cards[i]);
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-bp-card-swatch-image]');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('.bp-card');
    if (!card) return;

    // Swatches are <button>s; toggle active + aria-current across the set.
    card.querySelectorAll('[data-bp-card-swatch-image]').forEach(function (s) {
      s.classList.remove('bp-card__swatch--active');
      s.removeAttribute('aria-current');
    });
    swatch.classList.add('bp-card__swatch--active');
    swatch.setAttribute('aria-current', 'true');

    var imgUrl = swatch.dataset.bpCardSwatchImage;
    var img = card.querySelector('[data-bp-card-image-primary]');
    if (img && imgUrl) { img.src = imgUrl; img.removeAttribute('srcset'); }

    var hoverUrl = swatch.dataset.bpCardSwatchHover;
    var hoverImg = card.querySelector('[data-bp-card-image-secondary]');
    if (hoverImg && hoverUrl) {
      var preload = new Image();
      preload.onload = function () { hoverImg.src = hoverUrl; hoverImg.removeAttribute('srcset'); };
      preload.src = hoverUrl;
    }

    var price = swatch.dataset.bpSwatchPrice;
    var compare = swatch.dataset.bpSwatchCompare;
    var priceEl   = card.querySelector('.bp-card__price, [data-bp-card-price]');
    var compareEl = card.querySelector('.bp-card__compare, [data-bp-card-compare]');
    if (priceEl && price) priceEl.textContent = price;
    if (compareEl) {
      if (compare) { compareEl.textContent = compare; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }

    var siblingUrl = swatch.dataset.bpVariantUrl;
    if (siblingUrl) {
      card.querySelectorAll('a.bp-card__media-link, .bp-card__title a, [data-bp-card-product-link]')
        .forEach(function (a) { a.href = siblingUrl; });
    }

    // Colour-name label: on BP colorway cards the variant is a size, so the
    // colour only changes via the swatch — reflect the clicked colour here.
    // Reads the swatch's explicit colour, falling back to its accessible
    // name. (Empty leaves the previous value rather than blanking it.)
    var swatchColor = swatch.dataset.bpCardSwatchColor
      || swatch.getAttribute('aria-label') || '';
    if (swatchColor) {
      var nameEl = card.querySelector('[data-bp-card-color-name]');
      if (nameEl) { nameEl.textContent = swatchColor; nameEl.hidden = false; }
    }

    // Refresh the product name for the newly-selected colour (Atlas parity).
    cleanCardTitle(card);
  }, true);

  // Initial pass + re-run whenever the DOM changes (BR grid render, swatch
  // hydration, recommendations swap). Debounced; each write is guarded so
  // this never loops on its own mutations.
  var cleanTimer = null;
  function scheduleClean() {
    if (cleanTimer) return;
    cleanTimer = setTimeout(function () { cleanTimer = null; cleanAllCardTitles(); }, 80);
  }
  if (document.readyState !== 'loading') cleanAllCardTitles();
  else document.addEventListener('DOMContentLoaded', cleanAllCardTitles);
  if (window.MutationObserver) {
    new MutationObserver(scheduleClean).observe(
      document.documentElement, { childList: true, subtree: true }
    );
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bp-search-drawer"] && !Shopify.designMode) return;
  try {
    // ── Shared Bloomreach helpers ─────────────────────────────────────────────
// Defined on window.bpBr so BpSearchResults (bp-search-results.liquid) can
// reuse them without duplicating code regardless of bundle concatenation order.
window.bpBr = window.bpBr || {};
Object.assign(window.bpBr, {
  uid() {
    // The _br_uid_2 cookie is stored URL-encoded, and every caller feeds this
    // into URLSearchParams (which encodes again) → a DOUBLE-encoded _br_uid_2
    // on the wire, which broke BR personalization/reporting (63% of calls,
    // per the BR audit). Decode here so the single URLSearchParams encoding
    // downstream yields a single-encoded value. Matches bp-badges.js /
    // bp-bloomreach-carousel.js, which already decode.
    const m = document.cookie.match(/(?:^|;\s*)_br_uid_2=([^;]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (_) { return m[1]; }
  },
  reqId() {
    return 'br_' + Math.floor(Math.random() * 1e10);
  },
  config() {
    return window.shop?.br ?? {};
  },
  formatPrice(value) {
    if (value == null || value === '') return '';
    // Strip whole-dollar cents ($70.00 → $70), keep real cents ($70.50) — Atlas parity.
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
      .format(Number(value)).replace(/\.00$/, '');
  },
  esc(str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  },
  // Shopify-style handleize.
  handleize(s) {
    return String(s == null ? '' : s).toLowerCase().trim()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  },
  // The current colourway for a card: the colour whose handleized form is
  // the product handle's suffix. '' when none matches (e.g. pid-only feed).
  matchColor(handle, colors) {
    if (!handle || !Array.isArray(colors) || !colors.length) return '';
    for (let i = 0; i < colors.length; i++) {
      const ch = window.bpBr.handleize(colors[i]);
      if (ch && handle.length > ch.length + 1 && handle.slice(-(ch.length + 1)) === '-' + ch) {
        return colors[i];
      }
    }
    return '';
  },
  // Drop the trailing colourway from a product title (Atlas parity). Each
  // colorway is a separate product whose title carries the colour, so strip
  // the current colour (separator optional, case-insensitive). Only the
  // visible name uses this — alt / aria / GA4 keep the full title.
  stripTitleColor(title, handle, colors) {
    const color = window.bpBr.matchColor(handle, colors);
    if (!title || !color) return title;
    const c = String(color).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp('\\s*[-\\u2013\\u2014]?\\s*' + c + '\\s*$', 'i');
    const out = String(title).replace(re, '').trim();
    return out || title;
  },
  // BR docs carry no `sku`, but every BP image is named `<SKU>_SET….jpg`
  // and that leading token IS the inv7 SKU the GA4 items[] needs (item_id /
  // item_parent_id / item_variant). Validate the inv7 shape (digit + 2
  // letters + 4 digits) so a non-conforming asset falls back to "". Mirrors
  // skuFromImage in bp-bloomreach.js — kept here so search reuses it.
  skuFromImage(url) {
    // Filename (last path segment) — the CDN path has two `/files/` segments
    // (…/s/files/1/0529/…/files/<name>), so matching `/files/` grabs the
    // account id, not the asset name.
    const clean = String(url || '').split(/[?#]/)[0];
    const file = clean.slice(clean.lastIndexOf('/') + 1);
    const token = file.split(/[_.]/)[0].toUpperCase();
    return /^\d[A-Z]{2}\d{4}$/.test(token) ? token : '';
  },
  // Strip a wrong absolute origin from a Bloomreach url, keeping path + query
  // + hash, so the link resolves against the current shop origin. Relative or
  // hash urls (e.g. suggestProduct output) pass through unchanged.
  sameOriginUrl(u) {
    u = String(u || '');
    if (!u || u[0] === '/' || u[0] === '#') return u || '#';
    const m = u.match(/^https?:\/\/[^/]+(\/.*)?$/i);
    return m ? (m[1] || '/') : u;
  },
  productCard(p) {
    // Money: a real price is a positive number. Some feed items (Hanky
    // Panky) carry a 0 / blank `price` (list) while the true price lives in
    // `sale_price` — so a 0 list must never surface as "$0.00" or hide the
    // real price (QA: Brooke). Validate both, then pick the effective price.
    const _sale = p.sale_price != null ? Number(p.sale_price) : null;
    const _list = p.price != null ? Number(p.price) : null;
    const _validSale = _sale != null && !isNaN(_sale) && _sale > 0;
    const _validList = _list != null && !isNaN(_list) && _list > 0;
    const hasSale = _validSale && _validList && _sale < _list - 0.001;
    // Displayed price is always the real selling price, never 0/blank.
    const priceOut = hasSale ? _sale : _validList ? _list : _validSale ? _sale : null;
    const compareOut = hasSale ? _list : null;
    const esc = window.bpBr.esc;
    const fmt = window.bpBr.formatPrice;

    // Bloomreach core-search / trending docs carry an ABSOLUTE url whose host
    // is wrong off-prod — BR staging emits `https://staging.example.com/...`,
    // so the link opened a broken tab (Ernie QA 7/22). Strip the origin so the
    // path resolves against the current shop origin, keeping the query string
    // (Bloomreach's _br_psugg_q attribution). Already-relative urls from
    // suggestProduct pass through untouched.
    const url = window.bpBr.sameOriginUrl(p.url);

    // Visible name only: drop the trailing colourway (Atlas parity — the
    // colour is a separate product baked into the title). Match the colour
    // whose handleized form is the handle suffix, then strip it (separator
    // optional). alt / aria / GA4 keep the full p.title.
    const _handle = (String(url).match(/\/products\/([^/?#]+)/) || [])[1] || '';
    const cardName = (window.bpBr.stripTitleColor
      ? window.bpBr.stripTitleColor(p.title, _handle, p.colors)
      : p.title);

    // Brand eyebrow — "BRANDS WE LOVE: <brand>" for collective (BWL) items,
    // same as the PLP + Liquid cards. BR returns `brand` (= Shopify vendor);
    // house products are "Boston Proper", so only external brands get it.
    const brand = (p.brand || '').trim();
    const eyebrow = brand && brand.toLowerCase() !== 'boston proper'
      ? `<p class="bp-card__collection">Brands We Love: ${esc(brand)}</p>`
      : '';

    const img = p.thumb_image
      ? `<img
          class="bp-card__image bp-card__image--primary"
          src="${esc(p.thumb_image)}"
          alt="${esc(p.title)}"
          loading="lazy"
          data-bp-card-image-primary
        >`
      : '';

    // GA4 select_item payload (search experience). Mirrors the PLP card's
    // data-bp-track-product so bp-track-cards' delegated select_item handler
    // fires on a search product click (list "Search Results", location
    // "Search Experience", + the typed term — added in fireSelect). Sale
    // price/compare feed item_category3/original/discount.
    const trackJson = esc(JSON.stringify({
      id: p.pid,
      title: p.title,
      vendor: brand || 'Boston Proper',
      handle: (String(url).match(/\/products\/([^/?#]+)/) || [])[1] || '',
      url: url,
      image: p.thumb_image || '',
      sku: p.sku || '',
      category: p.category || '',
      selected_variant: {
        price: priceOut,
        compare_at_price: compareOut
      }
    }));

    return `<product-card class="bp-card-host">
      <article class="bp-card" data-product-id="${esc(p.pid)}" data-product-url="${esc(url)}" data-bp-track-product='${trackJson}'>
        <div class="bp-card__media">
          <a class="bp-card__media-link" href="${esc(url)}" aria-label="${esc(p.title)}" ref="productCardLink">
            ${img}
          </a>
          <div class="bp-card__badges" data-bp-card-badges></div>
        </div>
        <div class="bp-card__body">
          ${eyebrow}
          <h3 class="bp-card__title">
            <a href="${esc(url)}">${esc(cardName)}</a>
          </h3>
          <div class="bp-card__price-row">
            <span class="bp-card__price">${priceOut != null ? fmt(priceOut) : ''}</span>
            <s class="bp-card__compare"${compareOut != null ? '' : ' hidden'}>${compareOut != null ? fmt(compareOut) : ''}</s>
          </div>
          ${window.bpBr.swatches(p.colors)}
        </div>
      </article>
    </product-card>`;
  },
  // Initial swatches from BR's `colors` field — same markup as the PLP /
  // carousel (assets/bp-bloomreach.js). BpCardHydrate then upgrades these
  // to real per-colour images + links once the card scrolls into view.
  swatches(colors) {
    if (!Array.isArray(colors) || !colors.length) return '';
    const esc = window.bpBr.esc;
    const LIMIT = 8;
    const shown = [...new Set(colors)].slice(0, LIMIT);
    const items = shown.map((c) => {
      const css = String(c).toLowerCase().replace(/[^a-z]/g, '');
      return `<li class="bp-card__swatch-item"><span class="bp-card__swatch-img"
        style="background-color:${esc(css)};" role="img" aria-label="${esc(c)}" title="${esc(c)}"></span></li>`;
    }).join('');
    const overflow = colors.length > LIMIT
      ? `<li class="bp-card__swatch-more" aria-hidden="true">+${colors.length - LIMIT}</li>` : '';
    return `<ul class="bp-card__swatches" role="list" aria-label="Available colors">${items}${overflow}</ul>`;
  },

  // Map a Bloomreach autosuggest `searchSuggestions` (product suggestion)
  // item to the productCard shape. Autosuggest returns the selling price as
  // `sale_price` with no list `price`, so price = sale_price and sale_price is
  // cleared (no false strikethrough). The URL is made relative so it resolves
  // against the current origin (preview vs prod) while KEEPING Bloomreach's
  // `_br_psugg_q` attribution param (per BR docs). Shared by the drawer +
  // /search so both render the suggest window identically.
  suggestProduct(s) {
    const u = String(s.url || '');
    const m = u.match(/\/products\/[^#]*/);
    return {
      pid: s.pid,
      title: s.title || '',
      url: m ? m[0] : (u || '#'),
      thumb_image: s.thumb_image || '',
      price: s.sale_price != null ? s.sale_price : s.price,
      sale_price: null,
      brand: s.brand || '',
      colors: Array.isArray(s.colors) ? s.colors : [],
    };
  },

  // ── Shared search fetches + markup ──────────────────────────────────────
  // The drawer (BpSearchDrawer) and the /search page (BpSearchResults) call
  // these so both hit identical Bloomreach endpoints and render identical
  // sidebars + product grids. Keep the drawer and page visually in lockstep
  // by editing here, not in two places.

  // Bloomreach core SEARCH (product results).
  fetchSearch(q, { rows = 24, start = 0, viewId = '' } = {}) {
    const { accountId, host, domainKey, authKey } = window.bpBr.config();
    if (!accountId || !domainKey) return Promise.reject(new Error('br-config'));
    const params = new URLSearchParams({
      account_id:   accountId,
      domain_key:   domainKey,
      q,
      request_type: 'search',
      search_type:  'keyword',
      fl:           'pid,title,price,sale_price,thumb_image,url,brand,colors',
      start:        String(start),
      rows:         String(rows),
      url:          location.href,
      ref_url:      document.referrer || location.href,
      _br_uid_2:    window.bpBr.uid(),
      request_id:   window.bpBr.reqId(),
    });
    if (viewId) params.set('view_id', viewId);
    // auth_key sent only when configured (BR audit); never empty.
    if (authKey) params.set('auth_key', authKey);
    const endpoint = host || 'https://core.dxpapi.com/api/v1/core/';
    return fetch(`${endpoint}?${params}`).then((r) => {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  },

  // Bloomreach AUTOSUGGEST (keyword suggestions).
  fetchSuggest(q, { rows = 6 } = {}) {
    const { accountId, suggestHost, domainKey, authKey } = window.bpBr.config();
    if (!accountId || !domainKey) return Promise.reject(new Error('br-config'));
    const params = new URLSearchParams({
      account_id:    accountId,
      catalog_views: domainKey,
      q,
      request_type:  'suggest',
      search_type:   'keyword',
      url:           location.href,
      ref_url:       document.referrer || location.href,
      _br_uid_2:     window.bpBr.uid(),
      request_id:    window.bpBr.reqId(),
      rows:          String(rows),
    });
    // auth_key sent only when configured (BR audit); never empty.
    if (authKey) params.set('auth_key', authKey);
    const endpoint = suggestHost || 'https://suggest.dxpapi.com/api/v2/suggest/';
    return fetch(`${endpoint}?${params}`).then((r) => {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  },

  // Sidebar markup: keyword suggestions (the drawer's typed-state sidebar).
  suggestSidebarHtml(queries, q, searchUrl) {
    const escaped = window.bpBr.esc(q).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const links = (queries || []).slice(0, 8).map((sug) => {
      const term = sug.displayText || sug.query;
      const hl = window.bpBr.esc(term)
        .replace(new RegExp(`(${escaped})`, 'gi'), '<strong>$1</strong>');
      return `<li><a class="bp-sp__link" href="${searchUrl}?q=${encodeURIComponent(sug.query)}" data-bp-search="${window.bpBr.esc(sug.query)}">${hl}</a></li>`;
    }).join('');
    return `<div class="bp-sp__group">
          <h3 class="bp-sp__group-title">Suggestions</h3>
          <ul class="bp-sp__links" role="list">${links}</ul>
        </div>`;
  },

  // Product-grid markup: a heading + BP cards. `title` labels the group
  // ("Products" for results, "Trending Products" for the empty state).
  // `cta` adds the drawer's "View All Results" link ('view-all') or nothing
  // ('' — the /search page uses its own "Load more" footer outside this).
  productGridHtml(docs, { q = '', searchUrl = '/search', cta = '', title = 'Products' } = {}) {
    const cards = (docs || [])
      .map((p) => `<li class="bp-sp__item">${window.bpBr.productCard(p)}</li>`)
      .join('');
    const footer = cta === 'view-all'
      ? `<div class="bp-sp__footer">
          <a class="bp-sp__view-all" href="${searchUrl}?q=${encodeURIComponent(q)}">View All Results</a>
        </div>`
      : '';
    return `<h3 class="bp-sp__products-title">${window.bpBr.esc(title)}</h3>
        <ul class="bp-sp__grid" role="list">${cards}</ul>${footer}`;
  },

  // Bloomreach Pathways "trending" global widget — the empty-state products
  // (same widget id the drawer + card badges use). Returns [] on any failure.
  fetchTrending({ rows = 12 } = {}) {
    const { accountId, domainKey, authKey } = window.bpBr.config();
    if (!accountId) return Promise.resolve([]);
    const params = new URLSearchParams({
      account_id: accountId,
      domain_key: domainKey || 'bostonproper',
      rows:       String(rows),
      fields:     'pid,title,url,thumb_image,price,sale_price,colors',
      _br_uid_2:  window.bpBr.uid(),
      url:        location.href,
      ref_url:    document.referrer || location.href,
    });
    // auth_key sent only when configured (BR audit); never empty.
    if (authKey) params.set('auth_key', authKey);
    return fetch(`https://pathways.dxpapi.com/api/v2/widgets/global/6j835y6l?${params}`, { credentials: 'omit' })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => (d?.response?.docs) || [])
      .catch(() => []);
  }
});

// ── BpSearchDrawer ────────────────────────────────────────────────────────
class BpSearchDrawer extends HTMLElement {
  #ctrl = null;
  #suggestTimer  = null;
  #searchQuery   = '';
  #defaultSidebarHtml = '';

  connectedCallback() {
    this.#ctrl = new AbortController();
    const sig = this.#ctrl.signal;
    const input = this.querySelector('.bp-sd__input');
    const clear  = this.querySelector('.bp-sd__clear');
    this.brEnabled = this.dataset.brEnabled === '1';

    // Save default sidebar so it can be restored when input is cleared.
    const sidebar = this.querySelector('[data-br-sidebar]');
    if (sidebar) this.#defaultSidebarHtml = sidebar.innerHTML;

    // ── Neutralize Horizon's search modal entirely ──────────────────────────
    // Horizon's on:click="#search-modal/showDialog" calls showDialog() on the
    // dialog-component element, which in turn calls dialog.showModal(), placing
    // the <dialog> into the browser top layer with an invisible backdrop.
    // That backdrop intercepts all subsequent pointer events (including clicks
    // inside our panel), and Horizon's scroll-lock leaves the page frozen after
    // the dialog closes.  We patch every entry point to no-ops so none of this
    // ever fires, regardless of event-listener registration order.
    const searchModal = document.getElementById('search-modal');
    if (searchModal) searchModal.showDialog = () => {};

    const horizonDialogEl = document.querySelector('#search-modal dialog');
    if (horizonDialogEl) {
      horizonDialogEl.removeAttribute('scroll-lock');
      horizonDialogEl.showModal = () => {};
      horizonDialogEl.show     = () => {};
    }

    // ── Enter / submit → navigate to the full /search results PLP ──────────
    // The drawer shows live suggestions as you type; pressing Enter (or the
    // "View All Results" button, which submits this form) takes the shopper
    // to the full search page — filters, sort, quick-add, pagination.
    this.querySelector('.bp-sd__form')?.addEventListener('submit', (e) => {
      e.preventDefault();
      const q = input?.value.trim();
      if (!q) return;
      const searchUrl = this.dataset.searchUrl || '/search';
      window.location.href = searchUrl + '?q=' + encodeURIComponent(q);
    }, { signal: sig });

    // ── Keyword-suggestion clicks → the full /search results PLP ───────────
    // Any link carrying data-bp-search (static Popular Searches + autosuggest
    // keyword links) navigates to the search page for that term, matching the
    // Enter behavior above. Delegated so it covers re-rendered suggestions.
    // Links without the attribute (Category, Can-we-help) navigate normally.
    this.addEventListener('click', (e) => {
      const link = e.target.closest('[data-bp-search]');
      if (!link) return;
      e.preventDefault();
      const term = (link.getAttribute('data-bp-search') || '').trim();
      if (!term) return;
      const searchUrl = this.dataset.searchUrl || '/search';
      window.location.href = searchUrl + '?q=' + encodeURIComponent(term);
    }, { signal: sig });

    // ── Click interception ──────────────────────────────────────────────────
    window.addEventListener('click', this.#interceptSearch, { capture: true, signal: sig });
    document.addEventListener('click', this.#onOutside, { signal: sig });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.#isOpen) this.close();
    }, { signal: sig });

    input?.addEventListener('input', () => {
      clear.hidden = !input.value;
      this.#debouncedSuggest(input.value.trim());
    }, { signal: sig });

    clear?.addEventListener('click', () => {
      input.value = '';
      clear.hidden = true;
      input.focus();
      this.#searchQuery = '';
      this.#showDefaultState();
    }, { signal: sig });
  }

  disconnectedCallback() {
    this.#ctrl?.abort();
    clearTimeout(this.#suggestTimer);
    window.removeEventListener('scroll', this.#positionPanel);
    window.removeEventListener('resize', this.#positionPanel);
  }

  get #isOpen() { return this.classList.contains('bp-sd--open'); }

  #isSearchTrigger(el) {
    return !!el.closest('search-button, .search-action');
  }

  #interceptSearch = (e) => {
    if (!this.#isSearchTrigger(e.target)) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    this.#isOpen ? this.close() : this.open();
  };

  #onOutside = (e) => {
    if (!this.#isOpen) return;
    // Let the header search button toggle itself (handled in the capture
    // phase); don't double-handle it here.
    if (this.#isSearchTrigger(e.target)) return;
    // Close on any click outside the visible panel. The drawer shell
    // spans the whole viewport below the header, so checking the panel
    // (the white container) — not the shell — is what "click outside"
    // means to the user: clicking the nav, the dimmed page, anywhere
    // off the panel closes it.
    const panel = this.querySelector('.bp-sd__panel');
    if (panel && !panel.contains(e.target)) this.close();
  };

  // Dock the panel to the live bottom edge of the top chrome. Measure
  // the nav and the announcement bar DIRECTLY and take the lowest
  // bottom, rather than the #header-group wrapper: when the header goes
  // sticky, Horizon pulls the nav out of flow and the wrapper collapses
  // to ~0 height — measuring it then docked the panel at top:0, on top
  // of the nav. The nav's own bottom already includes the announcement
  // bar stacked above it (and tracks the sticky/slim state), so it's the
  // reliable anchor; the announcement bar is included for safety.
  #positionPanel = () => {
    let bottom = 0;
    ['#header-component', '.announcement-bar'].forEach((sel) => {
      const el = document.querySelector(sel);
      if (el) bottom = Math.max(bottom, el.getBoundingClientRect().bottom);
    });
    if (bottom <= 0) {
      const g = document.getElementById('header-group');
      if (g) bottom = g.getBoundingClientRect().bottom;
    }
    if (bottom > 0) this.style.setProperty('--bp-sd-top', `${Math.round(bottom)}px`);
  };

  open() {
    // a11y: remember what opened us so focus can return there on close.
    this._bpOpener = (document.activeElement instanceof HTMLElement) ? document.activeElement : null;
    const horizonDialogEl = document.querySelector('#search-modal dialog');
    if (horizonDialogEl?.open) horizonDialogEl.close();
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');

    this.#positionPanel();
    // Keep it docked while open — the sticky header shrinks/hides the
    // announcement bar on scroll, and the viewport can resize.
    window.addEventListener('scroll', this.#positionPanel, { passive: true });
    window.addEventListener('resize', this.#positionPanel, { passive: true });

    this.classList.add('bp-sd--open');
    this.setAttribute('aria-hidden', 'false');
    // a11y (WCAG 4.1.2): closed drawer is `inert` so the input inside an
    // aria-hidden container isn't focusable; lift it while open.
    this.removeAttribute('inert');

    const input = this.querySelector('.bp-sd__input');
    if (input?.value.trim()) {
      this.#debouncedSuggest(input.value.trim());
    } else {
      this.#showDefaultState();
    }

    requestAnimationFrame(() => input?.focus());
  }

  close() {
    window.removeEventListener('scroll', this.#positionPanel);
    window.removeEventListener('resize', this.#positionPanel);
    this.classList.remove('bp-sd--open');
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');

    // Reset so the next open starts clean — empty bar + trending, not the
    // previous query/results. Clearing the input is enough: open() shows
    // the default (trending) state whenever the input is empty. Restore
    // the state now too so a search's "N results / Back" sidebar doesn't
    // linger behind the fade-out.
    const input = this.querySelector('.bp-sd__input');
    if (input) { input.value = ''; input.setAttribute('aria-expanded', 'false'); }
    const clear = this.querySelector('.bp-sd__clear');
    if (clear) clear.hidden = true;
    this.#searchQuery = '';
    clearTimeout(this.#suggestTimer);
    this.#showDefaultState();

    // a11y: return focus to whatever opened the drawer (was dropping to body).
    if (this._bpOpener && typeof this._bpOpener.focus === 'function') {
      this._bpOpener.focus();
      this._bpOpener = null;
    }
  }

  // ── Bloomreach autosuggest ──────────────────────────────────────────────

  #debouncedSuggest(q) {
    clearTimeout(this.#suggestTimer);
    if (!q) { this.#showDefaultState(); return; }
    // Invalidate any pending trending render so it can't overwrite the
    // query results if it resolves late.
    this.#defaultToken = null;
    this.#suggestTimer = setTimeout(() => {
      if (!this.brEnabled) { this.#fetchNativeSuggest(q); return; }
      // ONE call: Bloomreach autosuggest returns BOTH keyword suggestions
      // (sidebar) AND product suggestions (cards). #renderSuggest renders the
      // ~5 product cards from `searchSuggestions`; it falls back to a live core
      // search only when autosuggest returns no products for the query.
      // (Bloomreach enabled "product suggestion in the autosuggest API"
      // (Akash, 7/21), so we no longer fire a separate core-search on every
      // keystroke to populate the suggest window.)
      this.#fetchSuggest(q);
    }, 250);
  }

  // ── Native fallback (Bloomreach off): Shopify's own predictive search ──
  // ONE Section Rendering API request against sections/bp-predictive-
  // search.liquid returns real bp-product-card HTML for the suggestion
  // window — same markup as every other card on the site, no JSON parsing
  // or hand-built card strings needed on this side (contrast with the BR
  // path above, which must build cards in JS since the data comes from an
  // external API).
  async #fetchNativeSuggest(q) {
    const base = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.predictive_search_url) || '/search/suggest';
    const params = new URLSearchParams({
      q,
      'resources[type]': 'product,query',
      'resources[limit]': '6',
      'resources[limit_scope]': 'each',
      section_id: 'bp-predictive-search',
    });
    try {
      const res = await fetch(`${base}?${params}`);
      if (!res.ok) return;
      // Drop a stale response if the shopper kept typing.
      if (this.querySelector('.bp-sd__input')?.value.trim() !== q) return;
      this.#renderNativeSuggest(await res.text(), q);
    } catch (_) { /* silently fail — don't break the search experience */ }
  }

  // Both fragments (sidebar suggestions + product cards) come pre-rendered
  // with fully-formed URLs from sections/bp-predictive-search.liquid — no
  // searchUrl needed here, unlike the BR render paths above which build
  // hrefs by hand in JS.
  #renderNativeSuggest(html, q) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const sidebarFrag  = doc.querySelector('[data-bp-native-sidebar]');
    const productsFrag = doc.querySelector('[data-bp-native-products]');

    const sidebar = this.querySelector('[data-br-sidebar]');
    if (sidebar) {
      sidebar.innerHTML = (sidebarFrag && sidebarFrag.innerHTML.trim())
        ? sidebarFrag.innerHTML
        : this.#defaultSidebarHtml;
    }

    const productsEl = this.querySelector('[data-br-products]');
    if (!productsEl) return;
    if (productsFrag) {
      productsEl.hidden = false;
      productsEl.innerHTML = productsFrag.innerHTML;
      this.#hydrateCards(productsEl);
    } else {
      // predictive_search never populated (route/section mismatch) — fail
      // soft rather than show a stale/empty panel.
      productsEl.hidden = false;
      productsEl.innerHTML = `<p class="bp-sr__empty">No results for &ldquo;${window.bpBr.esc(q)}&rdquo;. Try a different search term.</p>`;
    }
  }

  async #fetchSuggest(q) {
    const { accountId, suggestHost, domainKey, authKey } = window.shop?.br ?? {};
    if (!accountId || !domainKey) {
      console.warn('[bp-search] Bloomreach credentials missing in window.shop.br:', window.shop?.br);
      return;
    }

    const params = new URLSearchParams({
      account_id:    accountId,
      catalog_views: domainKey,
      q,
      request_type:  'suggest',
      search_type:   'keyword',
      url:           location.href,
      ref_url:       document.referrer || location.href,
      _br_uid_2:     window.bpBr.uid(),
      request_id:    window.bpBr.reqId(),
      rows:          '6',
    });
    // auth_key sent only when configured (BR audit); never empty.
    if (authKey) params.set('auth_key', authKey);

    const endpoint = suggestHost || 'https://suggest.dxpapi.com/api/v2/suggest/';
    try {
      const res = await fetch(`${endpoint}?${params}`);
      if (!res.ok) return;
      this.#renderSuggest(await res.json(), q);
    } catch (_) { /* silently fail — don't break the search experience */ }
  }

  #renderSuggest(data, q) {
    const group    = data.suggestionGroups?.[0] ?? {};
    const queries  = group.querySuggestions  ?? [];
    const products = group.searchSuggestions ?? [];
    const searchUrl = this.dataset.searchUrl || '/search';

    // Sidebar: keyword suggestions replace the default static links.
    const sidebar = this.querySelector('[data-br-sidebar]');
    if (sidebar) {
      if (queries.length) {
        const escaped = window.bpBr.esc(q).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const links = queries.slice(0, 8).map(s => {
          const hl = window.bpBr.esc(s.displayText || s.query)
            .replace(new RegExp(`(${escaped})`, 'gi'), '<strong>$1</strong>');
          return `<li><a class="bp-sp__link" href="${searchUrl}?q=${encodeURIComponent(s.query)}" data-bp-search="${window.bpBr.esc(s.query)}">${hl}</a></li>`;
        }).join('');
        sidebar.innerHTML = `<div class="bp-sp__group">
          <h3 class="bp-sp__group-title">Suggestions</h3>
          <ul class="bp-sp__links" role="list">${links}</ul>
        </div>`;
      } else {
        sidebar.innerHTML = this.#defaultSidebarHtml;
      }
    }

    // Product cards (right panel): render the autosuggest product suggestions
    // (`searchSuggestions`, ~5) directly — no separate core-search call. Each
    // suggestion carries pid/title/thumb_image/sale_price/url (no list price /
    // brand / colors), so window.bpBr.suggestProduct maps it to the card shape.
    // If autosuggest returns no products for the query, fall back to a live
    // core search so the panel is never empty.
    const productsEl = this.querySelector('[data-br-products]');
    if (!productsEl) return;
    if (products.length) {
      const searchUrl2 = this.dataset.searchUrl || '/search';
      const cards = products.slice(0, 5)
        .map((s) => `<li class="bp-sp__item">${window.bpBr.productCard(window.bpBr.suggestProduct(s))}</li>`)
        .join('');
      productsEl.hidden = false;
      productsEl.innerHTML = `
        <h3 class="bp-sp__products-title">Products</h3>
        <ul class="bp-sp__grid" role="list">${cards}</ul>
        <div class="bp-sp__footer">
          <a class="bp-sp__view-all" href="${searchUrl2}?q=${encodeURIComponent(q)}">View All Results</a>
        </div>`;
      // Intentionally NOT hydrated: the suggest window is a lightweight preview
      // (title + image + price). Per-card swatch hydration would refire N
      // /products/{handle}.js calls and defeat the single-call goal; the full
      // /search results page still hydrates.
    } else {
      // No product suggestions for this query — keep the prior behaviour.
      this.#doSearch(q, { fromTyping: true });
    }
  }

  // ── Bloomreach full search (fired on form submit AND live while typing) ──
  // Same Bloomreach core-search call for both paths. On submit it also
  // rewrites the sidebar to a result count; when called live from typing
  // (opts.fromTyping) it renders only the product grid and leaves the
  // keyword-suggestion sidebar (#fetchSuggest) untouched. Cards use
  // window.bpBr.productCard — the BP card, not the Horizon default.
  async #doSearch(q, opts = {}) {
    this.#searchQuery = q;
    this.#defaultToken = null;   // a query supersedes trending
    const { accountId, host, domainKey, authKey } = window.shop?.br ?? {};
    if (!accountId || !domainKey) {
      console.warn('[bp-search] Bloomreach credentials missing in window.shop.br:', window.shop?.br);
      return;
    }

    const params = new URLSearchParams({
      account_id:   accountId,
      domain_key:   domainKey,
      q,
      request_type: 'search',
      search_type:  'keyword',
      fl:           'pid,title,price,sale_price,thumb_image,url,brand,colors',
      start:        '0',
      rows:         '24', // BR audit: keep rows <= 24
      url:          location.href,
      ref_url:      document.referrer || location.href,
      _br_uid_2:    window.bpBr.uid(),
      request_id:   window.bpBr.reqId(),
    });
    // auth_key sent only when configured (BR audit); never empty.
    if (authKey) params.set('auth_key', authKey);

    const endpoint = host || 'https://core.dxpapi.com/api/v1/core/';
    try {
      const res = await fetch(`${endpoint}?${params}`);
      if (!res.ok) return;
      // Drop a stale response if the shopper kept typing (live path only).
      if (opts.fromTyping && this.querySelector('.bp-sd__input')?.value.trim() !== q) return;
      this.#renderSearch(await res.json(), q, opts);
    } catch (_) { /* silently fail */ }
  }

  #renderSearch(data, q, opts = {}) {
    const docs      = data.response?.docs     ?? [];
    const numFound  = data.response?.numFound ?? 0;
    const searchUrl = this.dataset.searchUrl  || '/search';

    // Sidebar: result count + back link — but when the search is firing live
    // from typing, leave the keyword-suggestion sidebar (#fetchSuggest) alone.
    const sidebar = opts.fromTyping ? null : this.querySelector('[data-br-sidebar]');
    if (sidebar) {
      sidebar.innerHTML = `<div class="bp-sp__group">
        <p class="bp-sp__group-title">${numFound} result${numFound !== 1 ? 's' : ''} for &ldquo;${window.bpBr.esc(q)}&rdquo;</p>
        <ul class="bp-sp__links" style="margin-top:12px" role="list">
          <li><a class="bp-sp__link" href="#" data-br-back>&#8592; Back</a></li>
        </ul>
      </div>`;
      sidebar.querySelector('[data-br-back]')?.addEventListener('click', (e) => {
        e.preventDefault();
        this.#searchQuery = '';
        this.#showDefaultState();
      });
    }

    // Products: up to 6 cards + "View All Results" link.
    const productsEl = this.querySelector('[data-br-products]');
    if (!productsEl) return;

    if (docs.length === 0) {
      productsEl.hidden = false;
      productsEl.innerHTML = `<p class="bp-sr__empty">No results for &ldquo;${window.bpBr.esc(q)}&rdquo;. Try a different search term.</p>`;
      return;
    }

    const cards = docs
      .map(p => `<li class="bp-sp__item">${window.bpBr.productCard(p)}</li>`)
      .join('');

    productsEl.hidden = false;
    productsEl.innerHTML = `
      <h3 class="bp-sp__products-title">Products</h3>
      <ul class="bp-sp__grid" role="list">${cards}</ul>
      <div class="bp-sp__footer">
        <a class="bp-sp__view-all" href="${searchUrl}?q=${encodeURIComponent(q)}">View All Results</a>
      </div>`;
    this.#hydrateCards(productsEl);
  }

  // Trending products for the empty state — same Bloomreach Pathways
  // "trending" global widget the card badges use (assets/bp-badges.js →
  // WIDGETS.trending '6j835y6l'), but requesting full card fields
  // instead of just pid. Keep the widget id in sync with bp-badges.js.
  #trendingCache = null;

  #fetchTrending() {
    if (this.#trendingCache) return this.#trendingCache;
    const br = window.shop?.br ?? {};
    if (!br.accountId) return Promise.resolve([]);
    const params = new URLSearchParams({
      account_id: br.accountId,
      domain_key: br.domainKey || 'bostonproper',
      rows:       '12',
      fields:     'pid,title,url,thumb_image,price,sale_price,colors',
      _br_uid_2:  window.bpBr.uid(),
      url:        location.href,
      ref_url:    document.referrer || location.href,
    });
    // auth_key sent only when configured (BR audit); never empty.
    if (br.authKey) params.set('auth_key', br.authKey);
    const url = `https://pathways.dxpapi.com/api/v2/widgets/global/6j835y6l?${params}`;
    this.#trendingCache = fetch(url, { credentials: 'omit' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => (data?.response?.docs) || [])
      .catch((err) => {
        console.warn('[bp-search] trending fetch failed', err);
        return [];
      });
    return this.#trendingCache;
  }

  // Upgrade the freshly-rendered BR cards to the full BP treatment —
  // sibling-colour swatches (BpCardHydrate) + Bestseller/Trending badges
  // (BpBadges) — the same hand-off the PLP and BR carousel use. Both
  // globals load deferred, so poll briefly in case a fetch resolves
  // first. No-op if a helper is absent (cards still render, just plain).
  #hydrateCards(scope, left = 3000) {
    if (!scope) return;
    const hydrate = window.BpCardHydrate;
    const badges = window.BpBadges;
    if (hydrate?.observeCards) hydrate.observeCards(scope);
    if (badges?.applyToCards) badges.applyToCards(scope);
    if ((!hydrate || !badges) && left > 0) {
      setTimeout(() => this.#hydrateCards(scope, left - 150), 150);
    }
  }

  #showDefaultState() {
    const sidebar = this.querySelector('[data-br-sidebar]');
    if (sidebar && this.#defaultSidebarHtml) sidebar.innerHTML = this.#defaultSidebarHtml;
    const productsEl = this.querySelector('[data-br-products]');
    if (!productsEl) return;

    if (!this.brEnabled) {
      // Native fallback has no lightweight "trending" equivalent (that's a
      // Bloomreach Pathways widget) — just clear back to the static
      // Popular Searches / Category sidebar and hide the products panel.
      productsEl.hidden = true;
      productsEl.innerHTML = '';
      return;
    }

    // Render immediately, fill in when the widget resolves. A stamped
    // token guards against a race: if the user starts typing before the
    // fetch lands, we don't clobber their results with stale trending.
    const token = Symbol('trending');
    this.#defaultToken = token;
    productsEl.hidden = false;

    this.#fetchTrending().then((docs) => {
      if (this.#defaultToken !== token) return;   // superseded by a query
      if (!docs.length) { productsEl.hidden = true; return; }
      const cards = docs
        .map((p) => `<li class="bp-sp__item">${window.bpBr.productCard(p)}</li>`)
        .join('');
      productsEl.innerHTML = `
        <h3 class="bp-sp__products-title">Trending Products</h3>
        <ul class="bp-sp__grid" role="list">${cards}</ul>`;
      this.#hydrateCards(productsEl);
    });
  }

  #defaultToken = null;
}

if (!customElements.get('bp-search-drawer')) {
  customElements.define('bp-search-drawer', BpSearchDrawer);
}
  } catch(e) { console.error(e); }
})();

})();
